import { createGtm } from '@gtm-support/vue-gtm';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export default defineNuxtPlugin(({ vueApp }) => {
  const {
    public: { gtmId, environment },
  } = useRuntimeConfig();
  const loggingService = useLoggingService();
  const isProduction = environment === 'production';

  if (!gtmId) {
    loggingService.warn('No GTM ID found. Skipping GTM setup.');
    return;
  }

  if (import.meta.client) {
    const dom = useDom();

    if (!dom) {
      return;
    }

    const { window } = dom;
    const dataLayer = (window.dataLayer ??= []);

    window.gtag ??= (...args: unknown[]) => {
      dataLayer.push(args);
    };

    const TIME_TO_WAIT_FOR_UPDATE = 5000;

    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      wait_for_update: TIME_TO_WAIT_FOR_UPDATE,
    });
  }

  const gtm = createGtm({
    id: gtmId,
    defer: true,
    compatibility: false,
    enabled: true,
    debug: !isProduction,
    loadScript: true,
    vueRouter: useRouter(),
    trackOnNextTick: false,
  });

  vueApp.use(gtm);
});
